import Ajax from './Ajax'

const Offer = {
  getOffers: (filters = {}) => {
    const params = new URLSearchParams()
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') params.append(key, value)
    })
    return Ajax.get(`/offers?${params.toString()}`)
  },
  createOffer: (data) => {
    return Ajax.post('/offers', { data })
  },
  syncOffer: (id) => {
    return Ajax.put(`/offers/${id}/sync`, {})
  },
  cancelSyncOffer: (id) => {
    return Ajax.post(`/offers/${id}/cancel-sync`, {})
  }
}

export default Offer
